import React from 'react';
import {Badge, BadgeProps} from './GenericBadges';
import {badgeColors} from './badgeColors';

/**
 * The SALE badge applies the BE `Badge.Sale.colors` pair (threaded through by
 * `BadgeList`), falling back to the static sale red background / white text
 * when the backend does not supply them. See ASFE-14225.
 */
export const SaleBadge = (props: BadgeProps) => (
  <Badge
    {...props}
    textColor={props.textColor || badgeColors.colors.sale}
    backgroundColor={props.backgroundColor || badgeColors.backgroundColors.sale}
  />
);
